module.exports = __webpack_public_path__ + "static/media/matched-track.4a6ee557.mp3";